import { createEntityAdapter, type EntityAdapter } from '@ngrx/entity';
import { createFeatureSelector } from '@ngrx/store';

import { ENGINE_FEATURE_KEY } from '@blaze-runtime/engine-data-access';
import { type CanvasElement } from '@blaze-runtime/engine-domain';

import { type EngineState } from './engine.model';

/**
 * Reads the `engine` feature slice as {@link EngineState} — the engine's own fields, AI included.
 *
 * `runtime/engine/data-access` declares `getEngineStateBase` over the same slice for the part it
 * owns, and each editor slice declares one for its own fields. All return the identical state
 * object; they differ only in how much of it they promise is there.
 */
export const getEngineState = createFeatureSelector<EngineState>(ENGINE_FEATURE_KEY);

// For performance optimization reason, we use EntityAdapter mapped to element entities.
// why: stays here rather than in `engine/data-access` because `selectId` reads a concrete
// element, which does not compile in a library built on its own (ADR 0006).
export const entityAdapter: EntityAdapter<CanvasElement> = createEntityAdapter<CanvasElement>({
  selectId: (element) => element.id,
});
